import { max, isNumber, throttle } from "lodash";

declare const jQuery: any;
const $ = jQuery;

const $window = $(window);
const findMaxHeight: Function = window["iw"].layout.findMaxHeight;
const onSmallScreen: Function = window["iw"].breakpoints.onSmallScreen;
const onMediumScreen: Function = window["iw"].breakpoints.onMediumScreen;
const onLargeScreen: Function = window["iw"].breakpoints.onLargeScreen;

export function initTabbedContent(): void
{
	const $wraps = $(".tabbed-content");
	if ($wraps.length === 0)
	{
		return;
	}
	$wraps.each(function () {
		const $wrap = $(this);
		const $menuItems = $wrap.find("[data-for-tab]");
		const $views = $wrap.find("[data-tab]");
		const switchToTab = ($menuItem) => {
			$menuItems.removeClass("selected");
			$menuItem.addClass("selected");
			const id: string = $menuItem.attr("data-for-tab");
			$views.removeClass("selected");
			const $view = $views.filter(`[data-tab="${id}"]`);
			$view.addClass("selected");
			$views.find(".collapsible-sections").trigger("close-all");
			setTimeout(() => {
				$wrap.trigger("changed");
			}, 400); // wait for css transition to complete
		};
		const toggleStackedView = ($view) => {
			if ($view.hasClass("stack-open"))
			{
				$view.removeClass("stack-open");
			}
			else
			{
				$view.addClass("stack-open");
			}
		};
		$menuItems.click(function (ev) {
			switchToTab($(this));
			return false;
		});
		$views.find(".tabbed-content-view-heading").click(function (ev) {
			toggleStackedView($(this).closest("[data-tab]"));
			return false;
		});
		setupLayoutFix($wrap, $views);
	});
}

function setupLayoutFix($wrap, $views): void
{
	if (!$wrap.hasClass("stable-height"))
	{
		return;
	}
	const fix = (forceHeight?: number) => {
		$views.css({ height: "" });
		if (!isStacked($wrap))
		{
			let height: number = findMaxHeight($views);
			if (forceHeight)
			{
				height = max([forceHeight, height]);
			}
			$views.css({ height });
		}
	};
	fix();
	$(() => fix());
	$window.on("load resize", throttle(() => fix(), 80, { leading: true }));
	$wrap.on("changed", () => {
		fix();
	});
	$wrap.find(".collapsible-section").on("opened", function (ev, data) {
		let height: number = isNumber(data && data.height) ? data.height : undefined;
		if (height)
		{
			const $wrap = $(this).closest(".tabbed-content-view");
			if ($wrap.length > 0)
			{
				height += parseInt($wrap.css("padding-top"), 10) + parseInt($wrap.css("padding-bottom"), 10);
			}
		}
		fix(height);
	}).on("closed", () => {
		fix();
	});
}

function isStacked($wrap): boolean
{
	return (onLargeScreen() && $wrap.hasClass("stack-lg")) ||
		(onMediumScreen() && $wrap.hasClass("stack-md")) ||
		(onSmallScreen() && $wrap.hasClass("stack-sm"));
}
